import { isFeatureEnabled } from 'owa-feature-flags';
import { LinkProviderType } from 'owa-fileprovider-link';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export function isSupportedProviderType(providerType: LinkProviderType): boolean {
    switch (providerType) {
        case LinkProviderType.OneDrivePro:
        case LinkProviderType.OfficeOneDrivePro:
            return true;
        case LinkProviderType.OneDriveConsumer:
            return (
                isConsumer() ||
                isFeatureEnabled('doc-deprecateCloudy-preview') ||
                isFeatureEnabled('doc-deprecateCloudy-preview-thumbnailView') ||
                isFeatureEnabled('doc-link-filePicker')
            );
        case LinkProviderType.Dropbox:
        case LinkProviderType.Box:
        case LinkProviderType.GDrive:
            return isFeatureEnabled('doc-link-filePicker');
        default:
            return false;
    }
}
